// src/app/css.service.ts
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { lastValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { parse } from "css";

export interface FontDefinition {
  name: string;
  link: string;
}

export interface PageDefinition {
  layout: string;
  content: any[];
}

export interface TemplateDefinition {
  cssVariables: { [key: string]: string };
  name: string;
  preview: string;
  description: string[];
  fonts: FontDefinition[];
  colors: string[];
  css: string;
  front_cover: PageDefinition;
  table_of_contents: PageDefinition;
  products: PageDefinition;
  back_cover: PageDefinition;
  about_us: PageDefinition;
  wholesale_caption: string;
  retail_caption: string;
  images_max_columns: number;
  images_max_rows: number;
  images_size: number;
  images_resizing: string;
  caption_position: string;
  caption_size: number;
  caption_alignment_vertical: string;
  caption_alignment_horizontal: number;
  default_header: string;
  default_footer: string;
  flow_layout_columns: number;
  layout: string;
  template: string;
}

@Injectable({
  providedIn: "root",
})
export class TemplateLoaderService {
  constructor(private httpClient: HttpClient) {}

  async loadTemplateDefinition(url: string): Promise<TemplateDefinition> {
    const definition = await this.getDefinition(`${url}definition.json`);
    // const variables = await this.getCssVariables(`${url}variables.css`);
    definition.preview = `${url}preview.jpg`;
    // definition.colors = [
    //   variables["--primary-color"],
    //   variables["--secondary-color"],
    //   variables["--contrast-color"],
    // ];
    // definition.css = await this.loadCss(url);
    return definition;
  }

  async loadCss(url: string): Promise<string> {
    let observable = await this.httpClient
      .get(`${url}variables.css`, { responseType: "text" })
      .pipe();
    const variables = await lastValueFrom(observable);
    observable = await this.httpClient
      .get(`${url}styles.css`, { responseType: "text" })
      .pipe();
    const styles = await lastValueFrom(observable);
    return variables + "\n" + styles;
  }

  getDefinition(url: string): Promise<TemplateDefinition> {
    const observable = this.httpClient.get<TemplateDefinition>(url, {
      responseType: "json",
    });
    return lastValueFrom(observable);
  }

  getCssVariables(url: string): Promise<{ [key: string]: string }> {
    const observable = this.httpClient
      .get(url, { responseType: "text" })
      .pipe(map((cssContent) => this.extractCssVariables(cssContent)));
    return lastValueFrom(observable);
  }

  extractCssVariables(cssContent: string): { [key: string]: string } {
    const parsedCss = parse(cssContent);
    const variables: { [key: string]: string } = {};

    parsedCss.stylesheet.rules.forEach((rule: any) => {
      if (rule.selectors.includes(".nis-catalog")) {
        rule.declarations.forEach((declaration: any) => {
          if (declaration.property.startsWith("--")) {
            variables[declaration.property] = declaration.value;
          }
        });
      }
    });

    return variables;
  }
}
